import { Component, OnInit, Inject, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabDirective, TabsetComponent } from 'ngx-bootstrap/tabs/public_api';
import { ApiService } from 'src/app/_services/api.service';

@Component({
  selector: 'app-DataSales',
  templateUrl: './DataSales.component.html',
  styleUrls: ['./DataSales.component.scss']
})
export class DataSalesComponent implements OnInit {
  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  pageId: string;
  pageName: string = "Data Sales";
  id: number;
  open: boolean=true;
  tab='General Info'
  enable: boolean = true;
  randomBool: boolean = true;
  FaqData: any;
  FormData: any;
  date = new Date().getFullYear();

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
  }

  constructor(private actRoute: ActivatedRoute,  private apiService: ApiService,) {
    this.id = this.actRoute.snapshot.params.id;
  }

  onSelect(data: TabDirective): void {
    this.tab = data.heading;
    // console.log('tab ' + this.tab);
    if(!this.pageId) {

      this.apiService.getPage(this.pageName).subscribe(data => {
        this.pageId = data.id.toString();
        if(this.tab.toLowerCase() === 'faq') {
          this.getFaq();
        }
        else if(this.tab.toLowerCase() == 'forms') {
          this.getForm();
        }

      })
    }
    else {
      if(this.tab.toLowerCase() === 'faq') {
        this.getFaq();
      }
      else if(this.tab.toLowerCase() == 'forms') {
        this.getForm();
      }

    }

  }
  getFaq() {
    // console.log(this.pageName)
    this.apiService.getFaqByPage(this.pageId).subscribe(data => {
      this.FaqData = data;
      // console.log(data);
    })

  }

  getForm() {
    this.apiService.getFormByPage(this.pageId).subscribe(data => {
      this.FormData = data;

    })
  }

  ngAfterViewInit() {
    console.log(this.id);
  }
  ngOnInit() {
  }

}
